/**
 * Runtime config injected by the Go server into index.html as an inert JSON
 * block (CSP-safe, no inline JS):
 *
 *   <script type="application/json" id="adminer-config">
 *     {"apiBaseURL":"/api","version":"1.2.3"}
 *   </script>
 *
 * The Vite dev server serves the raw index.html without the block — fall back
 * to defaults so `pnpm dev` (with the /api proxy) just works.
 */
export interface RuntimeConfig {
  apiBaseURL: string;
  version: string;
}

const DEFAULTS: RuntimeConfig = { apiBaseURL: "/api", version: "dev" };

function readConfig(): RuntimeConfig {
  const el = document.getElementById("adminer-config");
  if (!el?.textContent) return DEFAULTS;
  try {
    const parsed = JSON.parse(el.textContent) as Partial<RuntimeConfig>;
    return {
      apiBaseURL: parsed.apiBaseURL || DEFAULTS.apiBaseURL,
      version: parsed.version || DEFAULTS.version,
    };
  } catch {
    return DEFAULTS;
  }
}

export const runtimeConfig: RuntimeConfig = readConfig();
